import { render } from "./CatalogTable.vue?vue&type=template&id=03cc3dda&scoped=true"
import script from "./CatalogTable.vue?vue&type=script&lang=js"
export * from "./CatalogTable.vue?vue&type=script&lang=js"

import "./CatalogTable.vue?vue&type=style&index=0&id=03cc3dda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03cc3dda"]])

export default __exports__